// extracted by mini-css-extract-plugin
export var addBtn = "itemReorder-module--add-btn--06554";
export var addField = "itemReorder-module--add-field--eafca";
export var addWrapper = "itemReorder-module--add-wrapper--93f5d";
export var deleteBtn = "itemReorder-module--deleteBtn--2712e";
export var item = "itemReorder-module--item--52cd8";
export var label = "itemReorder-module--label--00d78";